import "./WhyChoose.css";

export default function WhyChoose() {
  return (
    <section className="why-section section">
      <div className="container">
        <div className="reveal">
          <h2 className="section-title">Why Choose iGamesTech</h2>
          <p className="why-desc">
            With years of experience in game and app development, our expert team delivers scalable, secure, and visually engaging solutions trusted by
            clients worldwide.
          </p>
        </div>
      </div>
    </section>
  );
}
